import {
  AssessmentListItemType,
  AssessmentResultType,
  EngagementPlan,
  PatientEngagementPlan,
  PreviewAssessmentDetailsType,
  TaskDetailsType,
  TasksListItemType,
  TasksState,
  TaskSummaryType
} from '@redux/tasks/tasksTypes';
import { ReduxState } from '@redux/types';

const getTasksState = (state: ReduxState): TasksState => {
  return state.tasks;
};

export const getOrganizationTasksListSelector = (state: ReduxState): TasksListItemType[] => {
  return getTasksState(state).tasksList;
};

export const getTaskDetailsSelector = (state: ReduxState): Nullable<TaskDetailsType> => {
  return getTasksState(state).selectedTaskDetails;
};

export const getPersonUpcomingTasksSelector = (state: ReduxState): TasksListItemType[] => {
  return getTasksState(state).personUpcomingTasks;
};

export const getPersonTasksByDateRangeSelector = (state: ReduxState): TaskSummaryType[] => {
  return getTasksState(state).personTasksByDateRangeTasks;
};

export const getGeneratedMessageFromTaskMessageSelector = (state: ReduxState): Nullable<string> => {
  return getTasksState(state).generatedTaskMessage;
};

export const getGeneratedTaskNameFromTaskMessageSelector = (state: ReduxState): Nullable<string> => {
  return getTasksState(state).generatedTaskName;
};

export const getGeneratedTaskSummaryFromTaskMessageSelector = (state: ReduxState): Nullable<string> => {
  return getTasksState(state).generatedTaskSummary;
};

export const getEngagementPlansSelector = (state: ReduxState): EngagementPlan[] => {
  return getTasksState(state).engagementPlans;
};

export const getPatientEngagementPlansSelector = (state: ReduxState): PatientEngagementPlan[] => {
  return getTasksState(state).patientEngagementPlans;
};

export const getAssessmentsListSelector = (state: ReduxState): Nullable<AssessmentListItemType[]> => {
  return getTasksState(state).assessmentsList;
};

export const getSelectedAssessmentSelector = (state: ReduxState): Nullable<AssessmentListItemType> => {
  return getTasksState(state).selectedAssessment;
};

export const getPreviewAssessmentIdSelector = (state: ReduxState): Nullable<string> => {
  return getTasksState(state).previewAssessmentId;
};

export const getPreviewAssessmentDetailsSelector = (state: ReduxState): Nullable<PreviewAssessmentDetailsType | AssessmentResultType> => {
  return getTasksState(state).previewAssessmentDetails;
};
